import classNames from 'classnames';
import React, { FC } from 'react';

type FormLabelPropsType = {
  className?: string;
  label: string;
  required?: boolean;
};

const FormLabel: FC<FormLabelPropsType> = (props) => {
  const { label, className, required } = props;
  return (
    <>
      <span
        className={classNames(
          className,
          `${
            required &&
            'relative after:mx-[5px] after:absolute after:border-[3px] after:border-solid after:border-basic_red after:rounded-full'
          }`,
        )}
      >
        {label}
      </span>
    </>
  );
};

export default FormLabel;
